import { fetchProviderSchedules } from "@/api/providerDashboard";

export default {
  async loadSchedules() {
    try {
      const res = await fetchProviderSchedules({ limit: 1000 });
      if (res.data.status === 200) {
        this.allScheduleList = (res.data.data || []).sort((a, b) => {
          if (a.status === "cancelled" && b.status !== "cancelled") return 1;
          if (a.status !== "cancelled" && b.status === "cancelled") return -1;
          return new Date(a.date) - new Date(b.date);
        });
        this.attributes = this.allScheduleList.map((item, index) => {
          const reservationName =
            item.bookingType === "offline"
              ? "오프라인 예약"
              : item.name || (item.user && item.user.username) || "";
          const title =
            (item.time || "") + (reservationName ? ` ${reservationName}` : "");
          return {
            key: index,
            customData: {
              title,
              status: item.status,
              id: item._id,
            },
            dates: item.date,
          };
        });
        this.handleDate();
      }
    } catch (err) {
      console.error(err);
    }
  },
};
